module.exports = __webpack_public_path__ + "assets/images/project/banner_image_blueneutral.jpg?v=e1ae2ec6";